import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";

import { isFeatureActive } from "../../util/featureAccess/featureAccessUtils";
import DashboardAdminBidsCard from "./DashboardAdminBidsCard";
import DashboardAdminQuickLinksCard from "./DashboardAdminQuickLinksCard";
import DashboardAdminTwoDaySnapshotCard from "./DashboardAdminTwoDaySnapshotCard";

const AdminDashboard = (props) => {
  const renderPageContent = () => {
    return (
      <Grid
        container
        direction="row"
        spacing={1}
        sx={{
          justifyContent: "center",
          paddingLeft: "1rem",
          paddingRight: "1rem",
        }}
      >
        <Grid item xs={2.5}>
          <DashboardAdminQuickLinksCard isDesktopView={props.isDesktopView} userFeatures={props.userFeatures} />
        </Grid>
        {isFeatureActive(props.userFeatures, "bid") && (
          <Grid item xs={5}>
            <DashboardAdminBidsCard workgroupFilters={props.workgroupFilters} />
          </Grid>
        )}
        <Grid item xs={2.5}>
          <DashboardAdminTwoDaySnapshotCard
            workgroupFilters={props.workgroupFilters}
            userFeatures={props.userFeatures}
          />
        </Grid>
      </Grid>
    );
  };

  return <div className="App-contents enable-scroll">{renderPageContent()}</div>;
};

AdminDashboard.propTypes = {
  isDesktopView: PropTypes.bool.isRequired,
  workgroupFilters: PropTypes.array.isRequired,
  userFeatures: PropTypes.array.isRequired,
};

export default AdminDashboard;
